import React from 'react'
import { Link } from 'react-router-dom'

class PastShows extends React.Component {
  render () {
    return (
      <div className='past-shows'>
        <div>
          <section>
            <h1 className='header-title shows-list-title'>
              Past Shows
            </h1>
            <div className='shows-list-container'>
              <div className='shows-list'>
                <h3>2025</h3>
                {/*Elf!*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>November 28 to December 28</h4>
                    <p className='show-text-link'>
                      <a href='https://www.5thavenue.org/shows/2025-26/elf-the-musical/' target='_blank' rel='noopener noreferrer'>
                      Elf - The Musical
                      <br />
                      The Fifth Avenue Theatre (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*ASO - Dec 2025*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 8 Monday @ 7PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.auburnsymphony.org/202526-season/holiday-spectacular' target='_blank' rel='noopener noreferrer'>
                      Auburn Symphony Orchestra - Holiday Spectacular
                      <br />
                      Auburn Performing Arts Center (Auburn, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*PSQ - KEXP*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>November 16 Sunday @ 7PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.kexp.org/events/kexp-events/death-music-2025/' target='_blank' rel='noopener noreferrer'>
                      Passenger String Quartet - KEXP Presents Death & Music
                      <br />
                      Town Hall (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*KOTM - Whats going on fest*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>November 14 Friday @ 8PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.waynehorvitz.com/event/shmp-presents-whats-going-on-festival-at-the-royal-room-in-seattle-wa-5/' target='_blank' rel='noopener noreferrer'>
                      Kin of the Moon String Orchestra - What's Going On Fest
                      <br />
                      Good Shepherd Chapel Performance Space (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Village Theatre - Brigadoon*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 25 Saturday @ 2PM & 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://villagetheatre.org/see-a-show/brigadoon' target='_blank' rel='noopener noreferrer'>
                      Village Theatre - Lerner and Loewe's Brigadoon 
                      <br />
                      Everett Performing Arts Center (Everett, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Roman Goron - Earshot Jazz*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 19 Sunday @ 6PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.earshot.org/event/roman-goron-the-transient-arboretum/' target='_blank' rel='noopener noreferrer'>
                      Roman Goron - The Transient Arboretum
                      <br />
                      Town Hall - Forum (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*ASO - Oct 2025*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 12 Sunday @ 2:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.auburnsymphony.org/202526-season/this-beautiful-earth' target='_blank' rel='noopener noreferrer'>
                      Auburn Symphony Orchestra - This Beautiful Earth
                      <br />
                      Auburn Performing Arts Center (Auburn, WA)
                      </a>
                    </p>
                  </div>
                </div>

                {/*PSQ - Shoreline Music Summit*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 11 Saturday @ 8PM</h4>
                    <p className='show-text-link'>
                      Passenger String Quartet - Shoreline Music Summit
                      <br />
                      London Bridge Studios (Shoreline, WA)
                    </p>
                  </div>
                </div>
                {/*ASO - Ode to Joy*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>May 4 Sunday @ 2:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.auburnsymphony.org/202425-season/may' target='_blank' rel='noopener noreferrer'>
                      Auburn Symphony Orchestra - Ode to Joy
                      <br />
                      Federal Way Performing Arts and Event Center (Federal Way, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Blessed Sacrament*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>May 3 Saturday @ 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.blessed-sacrament.org/light' target='_blank' rel='noopener noreferrer'>
                      Song of Light
                      <br />
                      Blessed Sacrament Church (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*NOCCO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>April 27 Sunday @ 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.nocco.org/upcoming-events/2025/4/27/revel' target='_blank' rel='noopener noreferrer'>
                      NOCCO - Revel
                      <br />
                      Blessed Sacrament Church (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*NOCCO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>April 26 Saturday @ 2PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.nocco.org/upcoming-events/2025/4/26/revel' target='_blank' rel='noopener noreferrer'>
                      NOCCO - Revel
                      <br />
                      Seattle First Baptist Church (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Swan Lake*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>April 25 Friday @ 7PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.stgpresents.org/events/state-ballet-theatre-of-ukraine-live-symphony-orchestra-swan-lake/' target='_blank' rel='noopener noreferrer'>
                      State Ballet Theatre of Ukraine & Live Symphony Orchestra - Swan Lake
                      <br />
                      The Paramount Theatre (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Traver Gallery*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>April 19 Saturday @ 2:30-5PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.travergallery.com/exhibitions/preston-singletary-in-person-artist-talk-special-performance-project-2/' target='_blank' rel='noopener noreferrer'>
                      Preston Singletary + Rituals of Becoming 
                      <br />
                      Traver Gallery (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*PSQ - Kaylee Cole*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>April 17 Thursday @ 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://tickets.thetripledoor.net/eventperformances.asp?evt=2117' target='_blank' rel='noopener noreferrer'>
                      Kaylee Cole & Passenger String Quartet - Cole Does King
                      <br />
                      Triple Door (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Auburn Symphony Orchestra*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>April 6 Sunday @ 2:30</h4>
                    <p className='show-text-link'>
                      <a href='https://www.auburnsymphony.org/202425-season/april' target='_blank' rel='noopener noreferrer'>
                      Auburn Symphony Orchestra - Visions of America
                      <br />
                      Auburn Performing Arts Center (Auburn, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/* Bainbridge private event*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 27 Thursday</h4>
                    <p className='show-text-link'>
                      Emergence Films Female Focused Filmmaking Fundraiser - Featured soloist
                      <br />
                      (Bainbridge Island, WA)
                    </p>
                  </div>
                </div>
                {/* SU Choir*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 14 Friday @ 7:30PM</h4>
                    <p className='show-text-link'>
                      Seattle University Choirs - Featured Soloist
                      <br />
                      Seattle First Baptist Church (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*ASO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 1 Saturday @ 7PM</h4>
                    <p className='show-text-link'>
                      Auburn Symphony Orchestra 
                      <br />
                      Federal Way Performing Arts and Event Center (Federal Way, WA)
                    </p>
                  </div>
                </div>

                {/*PSQ private event */}    
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>January 31 Friday</h4>
                    <p className='show-text-link'>
                      Passenger String Quartet - Private Event
                      <br />
                      Climate Pledge Arena (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*ASO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>January 26 Sunday @ 2:30PM</h4>
                    <p className='show-text-link'>
                      Auburn Symphony Orchestra 
                      <br />
                      Auburn Performing Arts Center (Auburn, WA)
                    </p>
                  </div>
                </div>


                <h3>2024</h3>

                {/*Nutcracker shows */}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 26 Thursday @ 5:35PM</h4>
                    <p className='show-text-link'>
                      Pacific Northwest Ballet - Nutcracker
                      <br />
                      McCaw Hall, Seattle Center (Seattle, WA)
                    </p>
                  </div>
                </div>
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 24 Tuesday @ 12:35PM</h4>
                    <p className='show-text-link'>
                      Pacific Northwest Ballet - Nutcracker
                      <br />
                      McCaw Hall, Seattle Center (Seattle, WA)
                    </p>
                  </div>
                </div>
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 23 Monday @ 7:35PM</h4>
                    <p className='show-text-link'>
                      Pacific Northwest Ballet - Nutcracker
                      <br />
                      McCaw Hall, Seattle Center (Seattle, WA)
                    </p>
                  </div>
                </div>
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 22 Sunday @ 5:35PM</h4>
                    <p className='show-text-link'>
                      Pacific Northwest Ballet - Nutcracker
                      <br />
                      McCaw Hall, Seattle Center (Seattle, WA)
                    </p>
                  </div>
                </div>
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 21 Saturday @ 7:35PM</h4>
                    <p className='show-text-link'>
                      Pacific Northwest Ballet - Nutcracker
                      <br />
                      McCaw Hall, Seattle Center (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Earshot */}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>November 3 Sunday</h4>
                    <p className='show-text-link'>
                      Wayne Horvitz Conduction - What's Going On Festival
                      <br />
                      Royal Room (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*PSQ Bainbridge*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>November 1 Friday</h4>
                    <p className='show-text-link'>
                      Shelby Earl & Passenger String Quartet
                      <br />
                      Bainbridge Island Music of Art (Bainbridge Island, WA)
                    </p>
                  </div>
                </div>
                {/*Earshot shows */}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 24 Thursday</h4>
                    <p className='show-text-link'>
                      Wayne Horvitz Conduction - What's Going On Festival
                      <br />
                      Royal Room (Seattle, WA)
                    </p>
                  </div>
                </div>
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 20 Sunday</h4>
                    <p className='show-text-link'>
                      Samantha Boshnack - Earshot Jazz Festival
                      <br />
                      Raisbeck Auditorium, Cornish College of the Arts (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*ASO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 13 Sunday @ 2:30PM</h4>
                    <p className='show-text-link'>
                      
                      Auburn Symphony Orchestra 
                      <br />
                      Auburn Performing Arts Center (Auburn, WA)
                    </p>
                  </div>
                </div>
                {/*Kaley Lane Eaton*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 15 Fri @ 8PM</h4>
                    <p className='show-text-link'>
                      Kaley Lane Eaton Album "Lookout" Release Show
                      <br />
                      Chapel Performance Space at Good Shepherd Center (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*LWSO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 5 Tues @ 10AM / 11:30AM</h4>
                    <p className='show-text-link'>
                      Lake Washington Symphony Orchestra - Education Concerts
                      <br />
                      Overlake Christian Church (Redmond, WA)
                    </p>
                  </div>
                </div>
                {/*LWSO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 4 Mon @ 10AM / 11:30AM</h4>
                    <p className='show-text-link'>
                      Lake Washington Symphony Orchestra - Education Concerts
                      <br />
                      Overlake Christian Church (Redmond, WA)
                    </p>
                  </div>
                </div>
                {/*Sharon Williams*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 1 Fri @ 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.seattlesymphony.org/en/benaroyahall/bh-calendar/2023-2024/23sharon-nyree-williams' target='_blank' rel='noopener noreferrer'>
                      An Evening with Sharon Nyree Williams
                      <br />
                      Illsley Ball Nordstrom Recital Hall - Benaroya Hall (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*ASO - Lights Camera Action*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>February 24 Sat @ 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.auburnsymphony.org/202324-season/pops' target='_blank' rel='noopener noreferrer'>
                      Auburn Symphony Orchestra - Lights, Camera, Action!
                      <br />
                      Federal Way Performing Arts and Event Center (Federal Way, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Tomo - Skate Rink*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>February 23 Fri</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama
                      <br />
                      Southgate Roller Rink (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Auburn Symphony Orchestra*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>February 16 Fri @ 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.auburnsymphony.org/202324-season/chamberfeb' target='_blank' rel='noopener noreferrer'>
                      Auburn Symphony Orchestra - BRAVO Series String Quartet
                      <br />
                      Postmark Center for the Arts (Auburn, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*PSQ - Aquarium*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>February 8 Thurs</h4>
                    <p className='show-text-link'>
                      Passenger String Quartet - Seattle Aquarium Benefit
                      <br />
                      Seattle Aquarium (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Auburn Symphony Orchestra*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>January 28 Sun @ 2:30</h4>
                    <p className='show-text-link'>
                      <a href='https://www.auburnsymphony.org/202324-season/january' target='_blank' rel='noopener noreferrer'>
                      Auburn Symphony Orchestra - Love and Legends
                      <br />
                      Auburn Performing Arts Center (Auburn, WA)
                      </a>
                    </p>
                  </div>
                </div>
                <h3>2023</h3>
                {/*Elf in Concert*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 30 Sat @ 2PM</h4>
                    <p className='show-text-link'>
                      Elf in Concert
                      <br />
                      McCaw Hall (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Elf in Concert*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 29 Fri @ 7PM</h4>
                    <p className='show-text-link'>
                      Elf in Concert
                      <br />
                      McCaw Hall (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*LWSO Holiday Concert*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 16 Sat @ 3PM</h4>
                    <p className='show-text-link'>
                      Lake Washington Symphony Orchestra - Holiday Concert
                      <br />
                      Bastyr Chapel (Kenmore, WA)
                    </p>
                  </div>
                </div>
                {/*Nutcracker*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 3 Sun @ 2PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.emeraldballet.org/' target='_blank' rel='noopener noreferrer'>
                      Emerald Ballet Theatre Orchestra / Emerald Ballet Theatre presents Nutcracker
                      <br />
                      Northshore Performing Arts Center (Bothell, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Nutcracker*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 2 Sat @ 2PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.emeraldballet.org/' target='_blank' rel='noopener noreferrer'>
                      Emerald Ballet Theatre Orchestra / Emerald Ballet Theatre presents Nutcracker
                      <br />
                      Northshore Performing Arts Center (Bothell, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*John Van Deusen*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>December 1 Friday</h4>
                    <p className='show-text-link'>
                      <a href='https://www.eventbrite.com/e/john-van-deusen-featuring-the-passenger-string-quartet-at-brodniak-hall-tickets-717233052367' target='_blank' rel='noopener noreferrer'>
                      John Van Deusen featuring The Passenger String Quartet
                      <br />
                      Anacortes High School (Anacortes, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*PSQ James Bond Winery*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>November 26 Sun</h4>
                    <p className='show-text-link'>
                      Passenger String Quartet - James Bond Tribute
                      <br />
                      Story Cellars (Woodinville, WA)
                    </p>
                  </div>
                </div>
                {/*Paige Barnes*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>November 4 Saturday</h4>
                    <p className='show-text-link'>
                      <a href='https://www.eventbrite.com/e/night-music-an-evening-of-music-and-movement-tickets-698161147787?aff=oddtdtcreator' target='_blank' rel='noopener noreferrer'>
                      Paige Barnes - Night Music: An evening of music and movement
                      <br />
                      Chapel Performance Space (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Johnaye Kendrick - Grounded*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>November 2 Thursday @ 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.earshot.org/event/johnaye-kendrick-grounded/' target='_blank' rel='noopener noreferrer'>
                      Johnaye Kendrick - Grounded - Earshot Jazz Festival
                      <br />
                      Raisbeck Auditorium (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Matt Cameron / Wayne Horvitz*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 28 Saturday @ 7:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://theroyalroomseattle.com/event/matt-cameron-trio-wayne-horvitz-and-motel-7-featuring-matt-cameron/' target='_blank' rel='noopener noreferrer'>
                      Matt Cameron Trio // Wayne Horvitz and Motel 7 Featuring Matt Cameron
                      <br />
                      Royal Room (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*DOTA 2 Internationale*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 27 Friday @ 10AM</h4>
                    <p className='show-text-link'>
                      DOTA 2 - The International 2023
                      <br />
                      Climate Pledge Arena (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama - Rabbit Box*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 25 Wednesday</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama
                      <br />
                      Rabbit Box (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Auburn Symphony Orchestra*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 15 Sunday @ 2:30PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.auburnsymphony.org/' target='_blank' rel='noopener noreferrer'>
                      Auburn Symphony Orchestra
                      <br />
                      Auburn Performing Arts Center (Auburnm, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Sheridan Riley - Earshot Festival*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>October 12 Thursday @ 7PM</h4>
                    <p className='show-text-link'>
                      <a href='https://www.earshot.org/event/sheridan-riley/' target='_blank' rel='noopener noreferrer'>
                      Sheridan Riley - Earshot Jazz Festival
                      <br />
                      Chapel Performance Space (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Leanna Keith - Blood Sugar Rice*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>September 29 Friday</h4>
                    <p className='show-text-link'>
                      Leanna Keith - Blood Sugar Rice
                      <br />
                      Chapel Performance Space (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama - Clock-out Lounge*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>September 8 Friday</h4>
                    <p className='show-text-link'>
                      <a href='https://clockoutlounge.com/event-detail/13404068/clock-out-lounge-presents-tomo-nakayama-w-tito-ramsey-wall-drugs/' target='_blank' rel='noopener noreferrer'>
                      Tomo Nakayama - Clock Out Lounge
                      <br />
                      Clock Out Lounge (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama - Snohomish Block Party*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>August 26 Saturday</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama - Snohomish Block Party
                      <br />
                      Snohomish, WA
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama - The Thing*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>August 25 Friday</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama - The Thing Festival
                      <br />
                      Port Townsend, WA
                    </p>
                  </div>
                </div>
                {/*PSQ - Lincoln Barr*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>August 24 Thurs</h4>
                    <p className='show-text-link'>
                      Passenger String Quartet w/ Lincoln Barr 
                      <br />
                      Royal Room (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*PSQ - Sonic Guild*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>August 12 Saturday</h4>
                    <p className='show-text-link'>
                      Passenger String Quartet - Sonic Guild 
                      <br />
                      Montlake (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama - SLU Block Party*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>August 10 Thursday</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama - South Lake Union Block Party
                      <br />
                      SLU Discovery Center (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Erin Jorgensen Fest*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>August 3 Thursday</h4>
                    <p className='show-text-link'>
                      <a href='hhttps://www.erinjorgensenfestival.com/august-4.html' target='_blank' rel='noopener noreferrer'>
                      Erin Jorgensen Fest - Sew and Tell! (A non-musical mini class)
                      <br />
                      18th & Union Theater - 1406 18th Ave (Seattle, WA)
                      </a>
                    </p>
                  </div>
                </div>
                {/*Abbey Blackwell - Sunset Album Release Show*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>July 3 Monday</h4>
                    <p className='show-text-link'>
                      Abbey Blackwell - Album Release Show!
                      <br />
                      Sunset Tavern (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama - Porchlight Show*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>June 17 Sat</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama - Porchlight Coffee & Records 14th Anniversary
                      <br />
                      Sunset Tavern (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama - Buffalo Daughter*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>June 3 Sat</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama - Opening for Buffalo Daughter 
                      <br />
                      Substation (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Seattle Peace Chorus*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>May 29 Mon @ 3PM</h4>
                    <p className='show-text-link'>
                      Seattle Peace Chorus - Mozart Requiem Singalong
                      <br />
                      Seattle Center, Northwest Folklife (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Auburn Symphony Orchestra / Seattle Baroque Orchestra*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>May 14 Sun @ 2:30 PM</h4>
                    <p className='show-text-link'>
                    Auburn Symphony Orchestra and Seattle Baroque Orchestra
                      <br />
                      Federal Way Performing Arts and Event Center (Federal Way, WA)
                    </p>
                  </div>
                </div>
                {/*Seattle Chamber Orchestra*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>April 6 Wed</h4>
                    <p className='show-text-link'>
                      Seattle Chamber Orchestra
                      <br />
                      Plymouth Church (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Paul Kikuchi - Omoide*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 26 Sun</h4>
                    <p className='show-text-link'><a href='https://www.seattlerep.org/audience-programs/upcoming-events/past-events/what-is-home-japanese-american-stories-from-omoide/' target='_blank' rel='noopener noreferrer'>
                      Paul Kikuchi's In Shadows Performance
                      <br />
                      Seattle Repatory Theater Poncho Forum
                      </a>
                    </p>
                  </div>
                </div>
                {/*ASO-January*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 25 Sat</h4>
                    <p className='show-text-link'>
                      Auburn Symphony Orchestra
                      <br />
                      Federal Way Performing Arts Center
                    </p>
                  </div>
                </div>
                {/*Tomo*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 8 Wed</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama
                      <br />
                      Rabbit Box (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*PSQ*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Jan 31 Tues</h4>
                    <p className='show-text-link'>
                      Passenger String Quartet
                      <br />
                      Seattle Aquarium (Private Event)
                    </p>
                  </div>
                </div>
                {/*ASO-January*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Jan 29 Sun @ 2:30PM</h4>
                    <p className='show-text-link'>
                      Auburn Symphony Orchestra
                      <br />
                      Auburn Performing Arts Center
                    </p>
                  </div>
                </div>
                {/*PSQ*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Jan 20 Fri</h4>
                    <p className='show-text-link'>
                      Passenger String Quartet
                      <br />
                      Showbox SODO (Private Event)
                    </p>
                  </div>
                </div>

                <h3>2022</h3>
                {/*Nutcracker*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Dec 10 Sat 2PM</h4>
                    <p className='show-text-link'>
                      Nutcracker / Emerald Ballet Theatre / Emerald Ballet Theatre Orchestra
                      <br />
                      Northshore Performing Arts Center (Bothell, WA)
                    </p>
                  </div>
                </div>
                {/*Lee Oskar*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Oct 22 Sat</h4>
                    <p className='show-text-link'>
                      Lee Oskar / Passenger String Quartet
                      <br />
                      Northshore Performing Arts Center (Bothell, WA)
                    </p>
                  </div>
                </div>
                {/*Cumulus*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Oct 21 Fri</h4>
                    <p className='show-text-link'>
                      Cumulus CD Release Show
                      <br />
                      Fremont Abbey (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Auburn Symphony Orchestra*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Oct 10 Sun</h4>
                    <p className='show-text-link'>
                      Auburn Symphony Orchestra
                      <br />
                      Auburn Performing Arts Center
                    </p>
                  </div>
                </div>
                {/*Michael Buble*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Sept 28 Wed</h4>
                    <p className='show-text-link'>
                      Michael Buble
                      <br />
                      Climate Pledge Arena (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Michael Buble*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Sept 27 Tues</h4>
                    <p className='show-text-link'>
                      Michael Buble
                      <br />
                      Moda Center (Portland, OR)
                    </p>
                  </div>
                </div>
                {/*John Van Deusen*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Sept 16 Fri</h4>
                    <p className='show-text-link'>
                      John Van Deusen / Passenger String Quartet
                      <br />
                      Emerald City Trapeze Arts (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Sept 8 Thurs</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama
                      <br />
                      Triple Door (Seattle, WA)
                    </p>
                  </div>
                </div>
                {/*Head and the heart*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 12 Fri + 13 Sat</h4>
                    <p className='show-text-link'>
                      The Head and the Heart / Passenger String Quartet
                      <br />
                      Marymoor Park
                    </p>
                  </div>
                </div>
                {/*Tomo Nakayama*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 6 Sat</h4>
                    <p className='show-text-link'>Tomo Nakayama, KEXP 50th Anniversary
                    <br />
                    KEXP at Seattle Center, Gathering Space (Seattle, WA)</p>
                  </div>
                </div>
                {/*Tomo Nakayama*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 5 Fri</h4>
                    <p className='show-text-link'>Tomo Nakayama
                    <br />
                    W Hotel (Seattle, WA)</p>
                  </div>
                </div>
                {/*Tomo Nakayama*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>July 22 Fri</h4>
                    <p className='show-text-link'>
                      Tomo Nakayama
                      <br />
                      Timber Fest (Carnation, WA)
                    </p>
                  </div>
                </div>
                {/*Auburn Symphony Orchestra*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>July 7 Thurs</h4>
                    <p className='show-text-link'>Auburn Symphony Orchestra
                    <br />
                    Benaroya Hall (Seattle, WA)</p>
                  </div>
                </div>
                {/*Tomo Nakayama*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>June 3 Fri</h4>
                    <p className='show-text-link'>Tomo Nakayama
                    <br />
                    Tractor Tavern (Seattle, WA)</p>
                  </div>
                </div>
                {/*Seattle Peace Chorus*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>May 30 Mon</h4>
                    <p className='show-text-link'>Seattle Peace Chorus, Mozart Requium Singalong
                    <br />
                    Seattle Center, Intiman Courtyard (Seattle, WA)</p>
                  </div>
                </div>
                {/*PSQ & Goodnight Suzie*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>May 22 Sun</h4>
                    <p className='show-text-link'>Passenger String Quartet w/ Goodnight Suzie
                    <br />
                    Bake's Place (Bellevue, WA)</p>
                  </div>
                </div>
                {/*Jim Knapp Memorial / Scrape*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>May 9 Mon</h4>
                    <p className='show-text-link'>Scrape, Jim Knapp Celebration
                    <br />
                    Chapel Performance Space at Good Shepherd Center (Seattle, WA)</p>
                  </div>
                </div>
                {/*Lee Oskar / PSQ*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 11 Fri</h4>
                    <p className='show-text-link'><a href='https://tickets.thetripledoor.net/eventperformances.asp?evt=1868' target='_blank' rel='noopener noreferrer'>Passenger String Quartet w/ Lee Oskar
                    <br />
                    The Triple Door (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Tomo Nakayama*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>March 5 Sat</h4>
                    <p className='show-text-link'><a href='https://www.showboxpresents.com/events/detail/422616' target='_blank' rel='noopener noreferrer'>Tomo Nakayama (opening for The Dip)
                    <br />
                    Showbox (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Head and Heart / PSQ*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 26 Sat</h4>
                    <p className='show-text-link'>
                      Matty and Charity Gervais (The Head and the Heart) & The Passenger String Quartet
                      <br />
                      Manor House (Bainbridge Island)
                    </p>
                  </div>
                </div>

                <h3>2021</h3>
                {/*Andrea Bocelli*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Nov 3 Wed</h4>
                    <p className='show-text-link'><a href='https://climatepledgearena.com/event/andrea-bocelli/' target='_blank' rel='noopener noreferrer'>Andrea Bocelli
                    <br />
                    Climate Pledge Arena (Seattle, WA)</a></p>
                  </div>
                </div>

                {/*Tomo CD release show*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Sept 18 Sat</h4>
                    <p className='show-text-link'><a href='https://do206.com/events/2021/9/18/tomo-nakayama-tickets' target='_blank' rel='noopener noreferrer'>Tomo Nakayama (CD Release Show)
                    <br />
                    Neptune Theater (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Downtown Summer Sounds w/ Puget Sound Strings*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 1 Sun</h4>
                    <p className='show-text-link'><a href='https://downtownseattle.org/events/downtown-summer-sounds/' target='_blank' rel='noopener noreferrer'>
                      Downtown Summer Sounds w/ Puget Sound Strings
                    <br />
                    Westlake Park (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Downtown Summer Sounds w/ Puget Sound Strings*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>July 18 Sun</h4>
                    <p className='show-text-link'><a href='https://downtownseattle.org/events/downtown-summer-sounds/' target='_blank' rel='noopener noreferrer'>
                      Downtown Summer Sounds w/ Puget Sound Strings
                    <br />
                    Westlake Park (Seattle, WA)</a></p>
                  </div>
                </div>

                <h3>2020</h3>
                {/*Chris Icasiano CD Release*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 29 Sat</h4>
                    <p className='show-text-link'><a href='http://originarts.com/artists/artist.php?Artist_ID=180' target='_blank' rel='noopener noreferrer'>Chris Icasiano CD Release Show
                    <br />
                    Wing Luke Museum (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Scrape*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 13 Thurs 8PM</h4>
                    <p className='show-text-link'><a href='https://www.facebook.com/events/479052759449646/' target='_blank' rel='noopener noreferrer'>Scrape
                    <br />
                    Chapel Performance Space at Good Shepherd Center (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Kaley Eaton*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 21 Fri</h4>
                    <p className='show-text-link'><a href='http://www.kaleylaneeaton.com/' target='_blank' rel='noopener noreferrer'>Kaley Eaton: Cornish Faculty Composer Concert
                    <br />
                    Cornish College of Arts (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*NOCCO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 23 Sun 7:30PM</h4>
                    <p className='show-text-link'><a href='https://www.nocco.org/20192020-season' target='_blank' rel='noopener noreferrer'>North Corner Chamber Orchestra
                    <br />
                    Seattle Town Hall (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*NOCCO*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Feb 22 Sat 2PM</h4>
                    <p className='show-text-link'><a href='https://www.nocco.org/20192020-season' target='_blank' rel='noopener noreferrer'>North Corner Chamber Orchestra
                    <br />
                    Youngstown Cultural Arts Center (Seattle, WA)</a></p>
                  </div>
                </div>

                {/*Tomo / Ings*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>January 23 Thurs</h4>
                    <p className='show-text-link'><a href='https://www.eventbrite.com/e/hygge-party-with-ings-tomo-nakayama-sophia-duccini-fremont-abbey-tickets-79282655557' target='_blank' rel='noopener noreferrer'>Hygge Party w/ ings, Tomo Nakayama
                    <br />
                    Fremont Abbey (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Dessa / PSQ*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Jan 18 Sat</h4>
                    <p className='show-text-link'><a href='https://www.thecrocodile.com/e/dessa-with-string-quartet-75410311271/' target='_blank' rel='noopener noreferrer'>Dessa w/ String Quartet
                    <br />
                    The Crocodile (Seattle, WA)</a></p>
                  </div>
                </div>


                <h3>2019</h3>
                {/*Emerald Theater Nutcracker*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Dec 15 Sun (2PM)</h4>
                    <p className='show-text-link'><a href='http://npacf.org/the-nutcrackerupcoming-concerts-2' target='_blank' rel='noopener noreferrer'>The Nutcracker w/ Emerald Theatre Ballet Orchestra
                    <br />
                    Northshore Performing Arts Center (Bothell, WA)</a></p>
                  </div>
                </div>

                {/*Emerald Theater Nutcracker*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Dec 14 Sat (2PM)</h4>
                    <p className='show-text-link'><a href='http://npacf.org/the-nutcrackerupcoming-concerts-2' target='_blank' rel='noopener noreferrer'>The Nutcracker w/ Emerald Theatre Ballet Orchestra
                    <br />
                    Northshore Performing Arts Center (Bothell, WA)</a></p>
                  </div>
                </div>
                {/*Ings CD Release*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Nov 16 Sat</h4>
                    <p className='show-text-link'><a href='https://www.eventbrite.com/e/ings-album-release-ashley-eriksson-lake-guest-ballard-homestead-tickets-73881727235' target='_blank' rel='noopener noreferrer'>Ings Album Release Show
                    <br />
                    Ballard Homestead (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Ampersand*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Nov 7 Thurs (6PM)</h4>
                    <p className='show-text-link'><a href='https://forterra.org/event/ampersand-live-2019' target='_blank' rel='noopener noreferrer'>Ampersand Live w/ Tomo Nakayama
                    <br />
                    The Moore Theater (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Cabinet of Dr. Caligari*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Oct 31 Thurs</h4>
                    <p className='show-text-link'><a href='https://www.theroyalroomseattle.com/' target='_blank' rel='noopener noreferrer'>Live Soundtrack to Silent Film: The Cabinet of Dr. Caligari
                    <br />
                    The Royal Room (Seattle, WA)</a></p>
                  </div>
                </div>

                {/*The Who*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Oct 19 Sat</h4>
                    <p className='show-text-link'><a href='https://www.thewho.com/tour/' target='_blank' rel='noopener noreferrer'>The Who
                    <br />
                    T-Mobile Park (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Josh Groban*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 25 Sun</h4>
                    <p className='show-text-link'><a href='https://www.joshgroban.com/tour' target='_blank' rel='noopener noreferrer'>Josh Groban
                    <br />
                    Chateau Ste Michelle Winery (Woodinville, WA)</a></p>
                  </div>
                </div>
                {/*Josh Groban*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 24 Sat</h4>
                    <p className='show-text-link'><a href='https://www.joshgroban.com/tour' target='_blank' rel='noopener noreferrer'>Josh Groban
                  <br />
                  Chateau Ste Michelle Winery (Woodinville, WA)</a></p>
                  </div>
                </div>
                {/*Josh Groban*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 22 Thurs</h4>
                    <p className='show-text-link'><a href='https://www.joshgroban.com/tour' target='_blank' rel='noopener noreferrer'>Josh Groban
                  <br />
                  McMenamin's Edgefield Amphitheater (Troutdale, OR)</a></p>
                  </div>
                </div>
                {/*Josh Groban*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 20 Tues</h4>
                    <p className='show-text-link'><a href='https://www.joshgroban.com/tour' target='_blank' rel='noopener noreferrer'>Josh Groban
                  <br />
                  Les Schwab Amphitheater (Bend, OR)</a></p>
                  </div>
                </div>
                {/*Levi Gillis*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 16 Fri</h4>
                    <p className='show-text-link'><a href='http://levigillis.com/' target='_blank' rel='noopener noreferrer'>Levi Gillis
                  <br />
                  Chapel Performance Space at the Good Shepherd Center (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*PSQ*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 9 Fri</h4>
                    <p className='show-text-link'><a href='https://www.andrewjoslynmusic.com/passenger-string-quartet/' target='_blank' rel='noopener noreferrer'>Passenger String Quartet
                  <br />
                  Downtown Seattle</a></p>
                  </div>
                </div>
                {/*Scrape*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>Aug 1 Thurs</h4>
                    <p className='show-text-link'><a href='https://www.facebook.com/ScrapeMusic/' target='_blank' rel='noopener noreferrer'>Scrape
                  <br />
                  Chapel Performance Space at the Good Shepherd Center (Seattle, WA)</a></p>
                  </div>
                </div>
                {/*Mark Lanegan / PSQ*/}
                <div className='show-container'>
                  <div className='show-icon-wrapper'>
                    <img src='assets/violin.svg' alt='Violin Icon made by freepik.com from www.flaticon.com' className='icon-violin' />
                  </div>
                  <div className='show-text-wrapper'>
                    <h4 className='show-text-date'>July 12 Sat</h4>
                    <p className='show-text-link'><a href='http://artisthome.org/timber-outdoor-music-festival-lineup-announcement/' target='_blank' rel='noopener noreferrer'>Mark Lanegan & The Passenger String Quartet
                  <br />
                  Timber Music Festival (Carnation, WA)</a></p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className='home-contact-text'>
          <Link to='/contact' className='link pulse'>Say Hello <i class='fas fa-heart fa-spin fa-lg' /></Link>
        </div>
      </div>
    )
  }
}

export default PastShows




// WEBPACK FOOTER //
// ./src/routes/PastShows.js